import React from "react";
import { Switch } from "@app/shared/src/components_v2";

/**
 * An operable switch.
 *
 * The kit's `Switch` is presentational — it renders the track and knob and nothing else — so every
 * call site was wrapping it in its own `<button role="switch">` with its own aria wiring. Four
 * settings tabs' worth of that is four chances to forget `aria-checked` and ship a control a
 * screen reader reads as an unlabelled button.
 */
export const Toggle: React.FC<{
    on: boolean;
    onChange: (next: boolean) => void;
    /** Required: the switch itself renders no text, so without this it is announced as nothing. */
    label: string;
    disabled?: boolean;
}> = ({ on, onChange, label, disabled }) => (
    <button
        type="button"
        role="switch"
        aria-checked={on}
        aria-label={label}
        disabled={disabled}
        onClick={() => onChange(!on)}
        className="flex-none disabled:opacity-50"
    >
        <Switch on={on} />
    </button>
);
